import { Box, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";
import { PermissionAssignmentWithEntityIdSingle } from "./Domain/department-monitoring.types";
import { useTranslation } from "react-i18next";
import { LabeledOverflowLinearProgress } from "./partial/LabeledLinearProgress.partial";

export function MonitoringReportCardSubHeader({
  data,
  type
}: Readonly<{
  data: PermissionAssignmentWithEntityIdSingle;
  type: "employee" | "supervisor";
}>) {
  const { t } = useTranslation();
  const { resultingQuota, targetQuota } = data;
  const showWarning = resultingQuota <= targetQuota;

  return (
    <Box width={"100%"} display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <Box display="flex" alignItems={"center"}>
          <Typography sx={{ fontSize: "0.9rem" }}>
            {t(type === "employee" ? "Employee" : "Supervisor")}
          </Typography>
          {showWarning && <Warning color={"error"} sx={{ ml: 0.5, fontSize: "1rem" }} />}
        </Box>

        <LabeledOverflowLinearProgress
          max={targetQuota}
          value={resultingQuota}
          maxLabel={t("TargetQuota")}
          valueLabel={t("Current")}
          bottomLableFontSize="0.8rem"
          showWarning={showWarning}
        />
      </Box>
    </Box>
  );
}
